import { useCallback, useState } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// import { useTranslate } from 'src/locales';

import { Card, FormControl, Select } from '@mui/material';

import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import CardHeader from '@mui/material/CardHeader';
import ButtonBase from '@mui/material/ButtonBase';
import { usePopover } from '../../../../components/minimal/custom-popover';
import Chart, { useChart } from '../../../../components/minimal/chart';

// ----------------------------------------------------------------------

// interface Props extends CardProps {
//   chart: {
//     categories?: string[];
//     colors?: string[][];
//     series: {
//       year: string;
//       data: {
//         name: string;
//         data: number[];
//       }[];
//     }[];
//   };
// }

// const subheader = '(+43%) than last year';

type dates = {
  months: { month: number }[];
};

type countPerMonths = {
  months: { count: number }[];
};

export default function TotalUserChallenges({ statistics }: { statistics?: any }) {
//   const { t } = useTranslate();
  const [seriesData, setSeriesData] = useState('Monthly');
  const [yearFilter, setYearFilter] = useState<number>(0);
  // let array = Array(12).fill(0);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const date = statistics?.totalUserChallengesPerMonth?.map((item: dates, index: number) =>
    item?.months.map((m: { month: number }) => (index === yearFilter ? months[m.month - 1] : []))
  ) || [];

  const monthlyUserChallenges = statistics?.totalUserChallengesPerMonth?.map(
    (item: countPerMonths) =>
      item?.months.map((m: { count: number }) => m?.count) || []
  ) || [];
  
  const yearlyUserChallenges = statistics?.totalUserChallengesPerMonth?.map(
    (item: { count: number }) => item?.count || 0
  ) || [];

  const year = statistics?.totalUserChallengesPerMonth?.map((item: { year: number }) => item?.year) || [];

  const chart = {
    categories: seriesData === 'Monthly' && date && date[yearFilter] ? date[yearFilter] : year,
    series: [
      {
        year: 'Monthly',
        data: [
          {
            name: 'User Challenge',
            data: monthlyUserChallenges?.[yearFilter] || [],
          },
        ],
      },
      {
        year: 'Yearly',
        data: [
          {
            name: 'User Challenge',
            data: yearlyUserChallenges || [],
          },
        ],
      },
    ],
  };
  

  const theme = useTheme();
  const title = 'Total User Challenges';
  const filter = [
    // t('statistics.students.daily'),
    'Yearly',
    'Monthly',
  ];
  const {
    // colors = [
    //   [theme.palette.primary.light, theme.palette.primary.main],
    //   [theme.palette.warning.light, theme.palette.warning.main],
    // ],
    categories,
    series,
    // options,
  } = chart;

  const popover = usePopover();

  const chartOptions = useChart({
    colors: ['#4D347C', '#FF9AA7'],
    // fill: {
    //   type: 'gradient',
    //   gradient: {
    //     colorStops: colors.map((colr) => [
    //       { offset: 0, color: colr[0], opacity: 1 },
    //       { offset: 100, color: colr[1], opacity: 1 },
    //     ]),
    //   },
    // },
    legend: {
      position: 'bottom',
      offsetX: 300,
      horizontalAlign: 'left',
    },
    xaxis: {
      categories,
    },
  });

  const handleChangeSeries = useCallback(
    (newValue: string) => {
      popover.onClose();
      setSeriesData(newValue);
    },
    [popover]
  );

  return (
    <Grid>
      <Card>
        <CardHeader
          title={title}
          //   subheader={subheader}
          action={
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Box sx={{ width: 120 }}>
                <FormControl fullWidth>
                  {seriesData === 'Monthly' && (
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // disabled={seriesData !== t('statistics.students.monthly')}
                      size="small"
                      fullWidth
                      defaultValue="all"
                      displayEmpty
                    >
                      <MenuItem disabled value="all">
                        {' '}
                        {'Year'}
                      </MenuItem>
                      {year.length === 0 ? (
                        <MenuItem disabled>No Data Available</MenuItem>
                      ) : (
                        year.map((item: number, index: number) => (
                          <MenuItem value={item} onClick={() => setYearFilter(index)}>
                            {item}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  )}
                </FormControl>
              </Box>

              <Card sx={{ display: 'flex', px: 2, py: 0.5 }}>
                {filter.map((item) => (
                  <ButtonBase
                    key={item + 'user-challenge'}
                    onClick={() => setSeriesData(item)}
                    sx={{
                      py: 0.5,
                      px: 1.5,
                      borderRadius: 3,
                      typography: 'subtitle2',
                      bgcolor: item == seriesData ? '#005639' : '',
                      color: item == seriesData ? 'white' : 'black',
                    }}
                  >
                    {item}
                  </ButtonBase>
                ))}
              </Card>
            </Box>
          }
        />

        {series.map((item) => (
          <Box key={item.year} sx={{ mt: 0, mx: 0 }}>
            {item.year === seriesData && (
              <Chart
                dir="ltr"
                type="line"
                series={item.data}
                options={chartOptions}
                width="100%"
                height={364}
              />
            )}
          </Box>
        ))}
      </Card>
    </Grid>
  );
}
